import React from 'react';
import { API_URL } from '../../api/client';
import { DbSearchResult } from '../../models/DbSearchResult';
import DbSearchResultsTable from './DbSearchResultsTable';
import './database.css';

interface DbSearchResultsComponentProps {
   searchResult: DbSearchResult;
}

const DbSearchResultsComponent = (props: DbSearchResultsComponentProps): React.JSX.Element => {
   return (
      <div id="db-search-results" style={{ textAlign: 'center', overflow: 'auto' }}>
         <div id="db-search-results-inner">
            <div id="db-search-summary" style={{ float: 'left', marginBottom: '0.8em' }}>
               <table id="db-search-summary-table">
                  <thead>
                     <tr>
                        <th colSpan={2}>Search Results Summary</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr>
                        <td>DB Entries</td>
                        <td style={{ textAlign: 'right' }}>{props.searchResult.summary?.num_entries}</td>
                     </tr>
                     <tr>
                        <td>Unique PDB IDs</td>
                        <td style={{ textAlign: 'right' }}>{props.searchResult.summary?.num_unique_pdb_ids}</td>
                     </tr>
                     <tr>
                        <td>Unique UniProt IDs</td>
                        <td style={{ textAlign: 'right' }}>{props.searchResult.summary?.num_unique_uniprot_ids}</td>
                     </tr>
                     <tr>
                        <td>Unique Target Ligands</td>
                        <td style={{ textAlign: 'right' }}>{props.searchResult.summary?.num_unique_target_ligands}</td>
                     </tr>
                  </tbody>
               </table>
            </div>

            {props.searchResult.empty ? (
               <div style={{ float: 'left', marginLeft: '5em', marginTop: '1.5em' }}>
                  No entries found in the database. You can try to run an{' '}
                  <a href="http://apoholo.cz">ad-hoc Apo-Holo search</a> for the protein chain of your interest.
               </div>
            ) : null}

            {!props.searchResult.empty && props.searchResult.showing_limited ? (
               <div style={{ float: 'left', marginLeft: '5em', marginTop: '1.5em' }}>
                  Showing first {props.searchResult.entries.length} out of {props.searchResult.summary?.num_entries}{' '}
                  entries. Restrict your search or use CSV export.
               </div>
            ) : null}

            <div
               id="db-search-results-btns"
               style={{ float: 'right', marginLeft: '5em', marginTop: '8.8em', marginBottom: '1em' }}
            >
               <a
                  id="download-all-btn"
                  href={`${API_URL}/api/db/search-results/download/ahojdb_search_results.zip?${props.searchResult.query.params_url}`}
               >
                  <button
                     className="btn btn-primary"
                     title="Download data related to all entries as a zip file. Note: potentially very large and slow download!"
                  >
                     Download all
                  </button>
               </a>
               <a
                  id="csv-export-btn"
                  href={`${API_URL}/api/db/search-results/export-csv?${props.searchResult.query.params_url}`}
               >
                  <button className="btn btn-primary" title="Export all entries to CSV">
                     CSV
                  </button>
               </a>
            </div>

            <DbSearchResultsTable value={props.searchResult.entries}></DbSearchResultsTable>
         </div>
      </div>
   );
};
export default DbSearchResultsComponent;
